import React from 'react';
import { User, Search, Handshake } from 'lucide-react';

const HowItWorksSection = () => {
  const steps = [
    {
      icon: <User className="w-12 h-12 text-yellow-400" />,
      title: 'Crie Seu Perfil Profissional',
      description:
        'Configure seu perfil completo e destaque sua experiência no mercado imobiliário.',
    },
    {
      icon: <Search className="w-12 h-12 text-yellow-400" />,
      title: 'Explore e Escolha Produtos',
      description:
        'Acesse nossa plataforma e escolha os imóveis que se alinham com seu público.',
    },
    {
      icon: <Handshake className="w-12 h-12 text-yellow-400" />,
      title: 'Conecte-se e Venda',
      description:
        'Use nossas ferramentas para conectar clientes aos imóveis ideais e feche mais negócios.',
    },
  ];

  return (
    <section className="bg-slate-900 py-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Como Criar Sua Sociedade Imobiliária na Prática
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-slate-800 border border-yellow-500/30 rounded-lg p-8 text-center hover:bg-slate-700 transition-all duration-300"
            >
              <div className="bg-yellow-400 text-slate-900 w-8 h-8 rounded-full flex items-center justify-center mx-auto mb-4 font-bold">
                {index + 1}
              </div>
              <div className="flex justify-center mb-6">{step.icon}</div>
              <h3 className="text-xl font-bold text-white mb-4">
                {step.title}
              </h3>
              <p className="text-gray-300">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
